<script>
	import BotonCaja from './../componentes/BotonCaja.svelte';
    import { breakpoint } from '../componentes/MediaQuery.svelte';
    import { moneda, object2array, postData } from "../scripts";
    import { sucursal, urlapi } from "../stores/store";
    import { createEventDispatcher } from 'svelte';
    
    export let cliente={};
    export let factura={};
    export let activo=true;

    export let countSelected=0;
    

    let offcanvas=false;
    let bsOffcanvas=false;
    let offcanvasClose=false;
    let productosFavoritos=[];
    export let checkButton=false;

    const dispatch = createEventDispatcher();

    postData($urlapi, [{ 'cmd':'productos_listAyuda','sucursal':$sucursal }])
    .then(data => {
        productosFavoritos=object2array(data[0].result.productos)
    });    

    export function openFavorito()
    {
        bsOffcanvas = new bootstrap.Offcanvas(offcanvas)
        bsOffcanvas.show()
    }

    function countSelecteds() {
        countSelected = factura.filter(function(item){
                if (item.selected === true) {
                    return true;
                } else {
                    return false;
                }
            }).length;
    }

    function selecIndex(index)
    {
        factura[index].selected=!factura[index].selected;
        countSelecteds()
    }

    export function checkAll()
    {
        checkButton=!checkButton;
        
        let ncarrito = factura.filter(function(item){
                item.selected=checkButton
                return true;
        })
        factura=[...ncarrito]
        countSelecteds()
    }

    export function deleteSelected()
    {
        let seleccionados = factura.filter(function(item){
                if (item.selected === true) {
                    return false;
                } else {
                    return true;
                }
        });
        factura=[...seleccionados]
        countSelected=0;
    }

    export function buscar_producto_nuevo()
    {
        
        let result = factura.findIndex(function(object) {
            return object.lock ===false;
        });
        
        if(result==-1) {
            let nuevo={ codigo:'',descripcion:'<span class="text-danger">PRODUCTO NO ASIGNADO</span>', cantidad:1,selected:false,lock:false,encontrado:false}
            factura=[...factura,nuevo]
        } else {
            document.getElementById('registro'+result).getElementsByTagName( 'input' )[1].focus()
            document.getElementById('registro'+result).getElementsByTagName( 'input' )[1].select()
        }
        linesReload();
    }

    let linesReload=function() {
        /*let lines=1;
        factura.forEach(function(element,index) {
            factura[index].linea=lines
            lines++;
        })*/
        dispatch('reload', {});        
    }

    function handleKeydown(event,campo,index)
    {
        if(event.keyCode==13)
        {
            if(campo=='codigo')
            {
                
                postData($urlapi, [{ 'cmd':'productos_search', 'codigo':factura[index].codigo }])
                .then(data => {
                    if(data[0].result===false)
                    {
                        factura[index].descripcion='<span class="text-danger">PRODUCTO NO ENCONTRADO</span>';
                    } else {
                        factura[index].descripcion=data[0].result.nombre;
                        factura[index].lock=true;
                        factura[index].encontrado=true;
                        document.getElementById('registro'+index).getElementsByTagName( 'input' )[2].focus()
                        document.getElementById('registro'+index).getElementsByTagName( 'input' )[2].select()
                    }
                });
                
            } else if (campo=='cantidad') {
                buscar_producto_nuevo()
            }
        }
    }
    
    export function addProductoFavorito(index)
    {
        bsOffcanvas.hide()
        let result = factura.findIndex(function(object) {
            return object.lock ===false;
        });
        if(result==-1) {
            let nuevo={ 
                codigo: productosFavoritos[index].codigo,
                descripcion: productosFavoritos[index].nombre,  
                cantidad:1,
                precio: productosFavoritos[index].precio,
                descuento:0,
                total:0,
                selected:false,
                lock:true,
                encontrado:true
            }
            factura=[...factura,nuevo]
            let indexer=factura.length-1;
            linesReload()

            setTimeout(() => {
                document.getElementById('registro'+indexer).getElementsByTagName( 'input' )[1].focus()
                document.getElementById('registro'+indexer).getElementsByTagName( 'input' )[1].select()
            }, 400);

        } else {
            factura[result]={ 
                codigo: productosFavoritos[index].codigo,
                descripcion: productosFavoritos[index].nombre, 
                cantidad:1,
                precio: productosFavoritos[index].precio,
                descuento:0,
                total:0,
                selected:false,
                lock:true,
                encontrado:true
            }
            linesReload()

            setTimeout(() => {
                document.getElementById('registro'+result).getElementsByTagName( 'input' )[1].focus()
                document.getElementById('registro'+result).getElementsByTagName( 'input' )[1].select()
            }, 400);
        }
        
    }
</script>

<!-- <div class='mb-1 pe-2'>
    <button disabled={activo || factura.pagado}
        class:btn-lg={$breakpoint === 'xxl'}
        class:btn-md={$breakpoint !== 'xxl'}
        class='btn btn-warning me-1' on:click={buscar_producto_nuevo}><i class="bi bi-cursor-text"></i><i class="bi bi-plus-lg"></i>
    </button><button disabled={activo || factura.pagado}
        class:btn-lg={$breakpoint === 'xxl'}
        class:btn-md={$breakpoint !== 'xxl'}
        class='btn btn-info' on:click={checkAll}>
            <i 
            class:bi-check-square={checkButton === true}
            class:bi-square={checkButton === false}
            class="bi"></i>
    </button>

    <div class="float-end">
        <button disabled={activo || factura.pagado}
            class:btn-lg={$breakpoint === 'xxl'}
            class:btn-md={$breakpoint !== 'xxl'}        
            class='btn btn-success' data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight"><i class="bi bi-cart-plus-fill"></i>
        </button>
        <button 
            class:btn-lg={$breakpoint === 'xxl'}
            class:btn-md={$breakpoint !== 'xxl'}        
            disabled={ !Boolean(Number(countSelected)) || activo  || factura.pagado} class='btn btn-danger' on:click={deleteSelected}><i class="bi bi-cart-dash-fill"></i><span class="badge bg-light text-danger ms-2 ps-1 pe-1">{countSelected}</span>
        </button>
    </div>
</div> -->

<div class="offcanvas offcanvas-end" style='width:700px;' bind:this={offcanvas} tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
    <div class="offcanvas-header">
      <h5 id="offcanvasRightLabel">Productos Favoritos</h5>
      <button type="button" bind:this={offcanvasClose} class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body pt-0">
        <div class='d-flex flex-wrap'>
            {#each productosFavoritos as item,index}
                    <BotonCaja on:click={()=>addProductoFavorito(index)} width='166px' id={item.id} image={item.image} color={item.color} precio={item.precio}>{item.nombre}</BotonCaja>
            {:else}
                    <p class='text-danger'>No hay productos favoritos</p>
            {/each}
        </div>
    </div>
</div>

<div class='scroll'
class:activo={cliente.activo === true}
class:noactivo={cliente.activo === false}
>
    <div class="tableFixHead">
        <table>
            <thead>
                <tr>
                    <th style='width:20px;' class='text-center'>&nbsp;</th>
                    <th style='width:50px;'>LÍNEA</th>
                    <th style='width:120px;'>CÓDIGO</th>
                    <th style='width:70px;'>CANTIDAD</th>
                    <th>DESCRIPCIÓN</th>
                </tr>

            </thead>
            <tbody>
                {#each factura as item,index}
                    <tr id='registro{index}' 
                        class:bg-gris={factura[index].lock===true}
                        class:bg-white={factura[index].lock===false}
                    >
                        <td>
                            <div class="form-check">
                               
                                <input 
                                    class:big-checkbox-xl={$breakpoint === 'xxl'}
                                    class:big-checkbox={$breakpoint !== 'xxl'}                                 
                                    disabled={activo} 
                                    class="form-check-input big-checkbox" 
                                    type="checkbox" 
                                    on:input={()=>selecIndex(index)} 
                                    bind:checked={factura[index].selected}>
                            </div>                            
                        </td>
                        <td><span class='ms-1'>{factura[index].linea}</span></td>
                        <td class='p-0'>
                            {#if factura[index].lock===true}
                                <span class='ms-1'>{factura[index].codigo}</span>
                            {:else}
                                <!-- svelte-ignore a11y-autofocus -->
                                <input type="text" class='inputProduct' 
                                on:keypress|self={(e)=>handleKeydown(e,'codigo',index)} 
                                bind:value={factura[index].codigo} autofocus>
                            {/if}
                        </td>
                        <td class='p-0'>
                            <input type="number" disabled={activo} min="1" class='inputProduct' 
                                on:keypress|self={(e)=>handleKeydown(e,'cantidad',index)} 
                                bind:value={factura[index].cantidad}
                                on:input={()=>dispatch('reload', {})}
                                >
                        </td>
                        <td>
                            {@html item.descripcion}
                        </td>
                    </tr>
                {:else}
                    <tr>
                        <td colspan='7'><span class='text-danger fw-bold'>SIN PRODUCTOS</span></td>
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>    
</div>

<style>
    .noactivo {
        /*height:600px;*/
        height:540px;
    }
    .activo {
        /*height:375px;*/
        height:315px;
    }
    .scroll {
        overflow-x: hidden;
        overflow-y: scroll;
        max-height:520px;        
    }
    .tableFixHead          { overflow: auto; height: 100%; }
    .tableFixHead thead th { position: sticky; top: 0; z-index: 1; }

    /* Just common table stuff. Really. */
    table  { border-collapse: collapse; width: 99%; }
    td { 
        font-size:0.8em;
        padding:4px;
        padding-right:10px;
        /*background-color: #eee;*/
        border-bottom:1px solid #aaa;
        border-right:1px solid #aaa;

    }
    th     { 
                background:#eee;
                font-size:0.7em;
                background:#212529;
                color:#fff;
                padding:4px;
           } 
    .big-checkbox {width: 20px; height: 20px;}
    .big-checkbox-xl {width: 30px; height: 30px;}
    .big-checkbox2 {width: 15px; height: 15px;}  
    .inputProduct {
        border:0px;
        border-radius: 0px;
        height:37px;
        width:98%;
    }
    .bg-gris {
        background-color:#eee;
    }
</style>